<template>
  <popup
    heading="New Ticket"
    button-text="Ticket"
    button-style="warning"
    :show-text="showText"
    button-icon="fa fa-exclamation-circle"
    :button-type="buttonType"
    :plain="plain"
    :round="round"
    @save="onSaveDialog"
    @close="onCloseDialog"
    :disable-button="enableSave">

  <div style="text-align: left;">
    <el-form ref="maintForm" :model="formData" label-width="120px">
    <el-tabs>
      <el-tab-pane label="Issue">

    <select-site v-if="!localSiteId" v-model="formData.site_id" show-site required />

<!-- TODO
    <site-card ref="siteCard" v-if="formData.site_id" :site-data="siteData" :sharer-id="isTelco() ? this.org().id : null" />
-->
    <select-ticket-category style="padding-top: 1em;" v-model="formData.category" :disabled="disabled" />

    <el-row style="clear: both;">
      <el-col :span="12">
        <select-action-status v-model="formData.status" :disabled="!this.isTowerCo()" />
      </el-col>

      <el-col :span="12">
        <select-priority v-model="formData.priority" />
      </el-col>
    </el-row>

    <el-form-item prop="issue" label="Details">
      <html-input v-model="formData.issue" />
<!--    <el-input type="textarea" :rows="3" v-model="formData.issue"  placeholder="Details of issue" />  -->
    </el-form-item>


  <select-organisation
    v-if="this.isTowerCo()"
    label="Reported by"
    v-model="formData.organisation_id" />

  <select-contractor  v-if="isTowerCo()" v-model="formData.contractor_id" />

    <!-- TODO fix this -->
    <select-workflow v-if="isTowerCo()" label="Workflow" v-model="formData.workflow_id" :disabled="true" />

</el-tab-pane>

<el-tab-pane label="Details"  v-if="this.isTowerCo()">
  <el-form-item prop="cause" label="Caused by">
    <el-input type="textarea" :rows="3" v-model="formData.cause" placeholder="Issue caused by" />
  </el-form-item>

  <el-form-item prop="fix" label="Fixed by">
    <el-input type="textarea" :rows="3" v-model="formData.fix" placeholder="Details of how the issue was fixed" />
  </el-form-item>

</el-tab-pane>


<el-tab-pane label="Scheduled" v-if="this.isTowerCo()">
  <el-row>
    <el-col :span="12">
      <switch-input
        v-model="formData.scheduledMaint"
        label="Repeated?"
        :disabled="disabled" />

    </el-col>

    <el-col :span="12">
      <select-frequency v-model="formData.schedFrequency" />
    </el-col>

    <el-col :span="12">
      <date-input
        label="Start"
        v-model="formData.schedStart"
        :options="dateOptions"
        :disabled="disabled" />
    </el-col>

    <el-col :span="12">
      <date-input
        label="End"
        v-model="formData.schedEnd"
        :options="dateOptions"
        :disabled="disabled" />
    </el-col>
  </el-row>
</el-tab-pane>

</el-tabs>
</el-form>
</div>
</popup>

</template>


<script>
import Vue from 'vue'
import VueEvents from 'vue-events'

import SiteMixins from '@/mixins/SiteMixins'

import {settings, ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT} from '@/components/Data'

import SelectContractor from '@/components/atoms/selects/SelectContractor'
import SelectPriority from '@/components/atoms/selects/SelectPriority'

import SelectTicketCategory from '@/components/atoms/selects/SelectTicketCategory'
import SelectWorkflow from '@/components/atoms/selects/SelectWorkflow'

import SelectActionStatus from '@/components/atoms/selects/SelectActionStatus'

import SiteCard from '@/components/sites/SiteCard'

Vue.use(VueEvents)

export default {
  mixins: [SiteMixins],

  components: {
    SelectContractor,
    SelectPriority,
    SelectActionStatus,
    SelectTicketCategory,
    SelectWorkflow,
    SiteCard
  },

  props: {
    rowData: {
      type: Object,
      required: false
    },

    assetId: {
      type: Number,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    },

    ownerId: {
      type: Number,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    buttonType: {
      type: String,
      default: null
    },

    plain: {
      type: Boolean,
      default: false
    },

    round: {
      type: Boolean,
      default: false
    },

    showText: {
      type: Boolean,
      default: true
    },

    size: {
      type: String,
      default: 'normal'
    },

    tableRef: {
      type: String,
      default: 'tickettable'
    }
  },

  methods: {

    resetData () {
      this.formData = this.getTableStruct('tickets')
      this.formData.site_id = this.localData.id
      this.$events.fire(DISABLE_SAVE_EVENT)
    },

    success (response) {
      this.$events.fire(this.tableRef + '-' + 'refresh-table')
      this.resetData()
    },

    selectedIssues () {
      this.formData.issue = this.$refs.issuenator.selected.currentLabel
    },

    onSaveDialog () {

      if (this.siteId) {
        this.formData.site_id = this.siteId
      }

      if (this.assetId) {
        this.formData.asset_id = this.assetId
      }

      if (this.ownerId) {
        this.formData.organistion_id = this.ownerId
      }

      if (!this.formData.organisation_id) {
        this.formData.organisation_id = this.org().id
      }

      this.formData.opened = this.formatDateTimeSql(this.formData.opened)
      this.formData.target = this.formatDateTimeSql(this.formData.target)
      this.formData.completedDate = this.formatDateTimeSql(this.formData.completedDate)

      this.formData.schedStart = this.formatDateTimeSql(this.formData.schedStart)
      this.formData.schedNext = this.formatDateTimeSql(this.formData.schedNext)
      this.formData.schedLast = this.formatDateTimeSql(this.formData.schedLast)
      this.formData.schedEnd = this.formatDateTimeSql(this.formData.schedEnd)

      this.saveForm(this, '/tickets', null, this.formData, this.formData.category, this.success)

//      this.resetData()
    },

    onCloseDialog () {
      this.resetData()
    }
  },

  computed: {
    enableSave: function () {
      if (this.formData.site_id && this.formData.category && this.formData.organisation_id) {
        this.$events.fire(ENABLE_SAVE_EVENT)
        return false
      } else {
        return false
      }
    }
  },

  data () {
    return {
      orgId: Number(this.org().id),
      dateFormat: settings.selectDateFormat,
      loading: false,
      issuenator: null,
      localData: this.rowData,
      localSiteId: (this.siteId ? this.siteId : (this.rowData && this.rowData.site_id && this.rowData.coverage ? this.rowData.id : null)),
      formData: this.getTableStruct('tickets'),
      dateOptions: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Next week',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }, {
          text: 'Next Month',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30)
            picker.$emit('pick', date)
          }
        }, {
          text: 'Next Year',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },

  mounted () {

    this.$events.fire(DISABLE_SAVE_EVENT)

    if (!this.formData.site_id && this.siteId) {
      this.formData.site_id = this.siteId
    }

    if (this.isTelco()) {
      this.formData.organisation_id = this.org().id
    }
  }

}

</script>
